// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","580":"43061601"}[chunkId] + ".chunk.js";
};